import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const comboboxSectionFn = /* @__PURE__ */ createRecipe('combobox-section', {}, [])

const comboboxSectionVariantMap = {}

const comboboxSectionVariantKeys = Object.keys(comboboxSectionVariantMap)

export const comboboxSection = /* @__PURE__ */ Object.assign(memo(comboboxSectionFn.recipeFn), {
  __recipe__: true,
  __name__: 'comboboxSection',
  __getCompoundVariantCss__: comboboxSectionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: comboboxSectionVariantKeys,
  variantMap: comboboxSectionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, comboboxSectionVariantKeys)
  },
  getVariantProps: comboboxSectionFn.getVariantProps,
})